import React, { useState, useEffect, useCallback, useRef } from 'react';
import * as Yup from 'yup';
import { toast } from 'react-toastify';
import { Form } from '@unform/web';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
// importando os services
import api from '~/services/api';
import history from '~/services/history';

// Componentes
import Input from '~/components/Form/Input';
import Button from '~/components/Form/Button';
import Select from '~/components/Form/Select';
import Card from '~/components/Card';

import { Container } from './styles';

export default function TemperaturaEdit({ match }) {
  const selectRef = useRef(null);
  const [times, setTimes] = useState([]);
  const [timeValue, setTimeValue] = useState({});
  const [dado, setDado] = useState([]);
  const [carregar, setCarregar] = useState(false);

  const user = useSelector(state => state.user.profile);

  // Buscando os dados da api
  const getDados = useCallback(async () => {
    try {
      const { id } = match.params;

      const responseDados = await api.get(`/temperaturas/${id}`);

      if (user.provider === '4') {
        const response = await api.get('/times-select');
        const data = response.data.map(res => {
          return {
            label: res.name,
            value: res.id,
          };
        });

        // Pegando o value do time
        const dataValueTime = data.filter(res => {
          return res.value === responseDados.data.time_id;
        });

        setTimes(data);
        setTimeValue(dataValueTime[0]);
      }
      setDado(responseDados.data);
    } catch (error) {
      toast.error('Error ao listar dados da temperatura');
    }
  }, [match.params, user.provider]);

  useEffect(() => {
    getDados();
  }, [getDados]);

  async function handlerSubmit(data, { reset }) {
    try {
      setCarregar(true);
      const { id } = match.params;
      selectRef.current.setErrors({});
      let schema;

      if (user.provider !== '4') {
        schema = Yup.object().shape({
          name: Yup.string().required('Preencha o campo nome'),
        });
      } else if (data.time_id === undefined) {
        schema = Yup.object().shape({
          name: Yup.string().required('Preencha o campo nome'),
        });
      } else {
        schema = Yup.object().shape({
          time_id: Yup.string('Selecione um time').required(
            'Selecione um time'
          ),
          name: Yup.string().required('Preencha o campo nome'),
        });
      }
      await schema.validate(data, {
        abortEarly: false,
      });

      const timeID =
        data.time_id === undefined ? timeValue.value : data.time_id;

      await api.put(`/temperaturas/${id}`, {
        time_id: user.provider === '4' ? timeID : dado.time_id,
        name: data.name,
      });

      toast.success('Temperatura editado com sucesso');

      reset();
      history.push('/temperatura');
    } catch (err) {
      setCarregar(true);
      const validationErrors = {};
      if (err instanceof Yup.ValidationError) {
        err.inner.forEach(error => {
          validationErrors[error.path] = error.message;
        });
        selectRef.current.setErrors(validationErrors);
      } else {
        toast.error('Error ao editar o temperatura, verifique os dados');
      }
    } finally {
      setCarregar(false);
    }
  }

  return (
    <Container>
      <h4>Editar Temperatura</h4>
      <Card>
        <Form
          initialData={dado}
          ref={selectRef}
          onSubmit={handlerSubmit}
          autoComplete="off"
        >
          {user.provider === '4' && (
            <Select
              name="time_id"
              labelSelect="Times"
              options={times}
              onChange={e => setTimeValue(e)}
              defaultValue={timeValue}
            />
          )}
          <Input icon="MdPerson" name="name" label="Nome" type="text" />
          <Button tamanho="40px" load={carregar}>
            Editar
          </Button>
        </Form>
      </Card>
    </Container>
  );
}

TemperaturaEdit.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string,
    }),
  }).isRequired,
};
